import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Row, Col, Form, Collapse, Input, Select, Switch, Checkbox, Radio } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { useGetCountriesNew } from 'all-in-one-shared-api';
// import TextArea from 'antd/es/input/TextArea';
// import { Spinner } from 'components';
import React, { useEffect, useState, useCallback } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { AgreementCard } from './Agreement/AgreementCard';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { MobileNumberHasAreaPrefix } from 'components';
import { mobileRegexNew, mobileRegexhk } from 'utils/regex';
import ChevronRight from 'assets/images/home/chevron-right.svg';
import { corrAddressListItem } from '../ChangeContactInformation';
import { canShowTax } from '../utile/canShowTax';
import CoverModal from './CoverModal';
// import { MarkdownTargetBlank } from 'components';
// import { Converter } from 'opencc-js';

// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
export const ChangeContactCard = (props: {
  policyTypesObject: corrAddressListItem[];
  emailphone: boolean;
  errorMessage: string;
  cantchageemail: boolean;
  cantchagephone: boolean;
  Message: string;
  tax1Value: string;
  tax2Value: string;
  showTaxItem: {
    mobileNumber: boolean;
    homeNumber: boolean;
    officeNumber: boolean;
    resAddress: boolean;
    corrAddress: boolean;
  };
  taxLink: {
    tax1: string;
    tax2: string;
  };
  setShowTaxItem: React.Dispatch<
    React.SetStateAction<{
      mobileNumber: boolean;
      homeNumber: boolean;
      officeNumber: boolean;
      resAddress: boolean;
      corrAddress: boolean;
    }>
  >;
  updateParentValue: React.Dispatch<React.SetStateAction<boolean>>;
  setTax1Value: React.Dispatch<React.SetStateAction<string>>;
  setTax2Value: React.Dispatch<React.SetStateAction<string>>;
  childRef: React.RefObject<HTMLDivElement>;
  activeKey1: string;
  activeKey2: string;
  activeKey3: string;
  setActiveKey1: React.Dispatch<React.SetStateAction<string>>;
  setActiveKey2: React.Dispatch<React.SetStateAction<string>>;
  setActiveKey3: React.Dispatch<React.SetStateAction<string>>;
  mobilePhoneCountryCodeName: string;
  homePhoneCountryCodeName: string;
  officePhoneCountryCodeName: string;
  setmobilePhoneCountryCodeName: React.Dispatch<React.SetStateAction<string>>;
  sethomePhoneCountryCodeeName: React.Dispatch<React.SetStateAction<string>>;
  setofficePhoneCountryCodeName: React.Dispatch<React.SetStateAction<string>>;
  homeAreaCodeFlag: string;
  officeAreaCodeFlag: string;
  mobileAreaCodeFlag: string;
  mobilePhoneCountryCodeNameOri: string;
  homePhoneCountryCodeNameOri: string;
  officePhoneCountryCodeNameOri: string;
  setmobilePhoneCountryCodeNameOri: React.Dispatch<React.SetStateAction<string>>;
  sethomePhoneCountryCodeeNameOri: React.Dispatch<React.SetStateAction<string>>;
  setofficePhoneCountryCodeNameOri: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { t, i18n } = useTranslation();
  const form = useFormInstance();
  const { token } = useKeycloakReady();

  const [mrchecked, setmrchecked] = useState<boolean>(false);
  // const [checkOne, setCheckedOne] = useState<boolean[]>(Array(props.policyTypesObject.length).fill(false));
  const [SwichCode, setSwich] = useState<boolean>((form.getFieldValue('selectedPolicy') ?? []).length > 0);
  // const [residentialAddressCountry, setresidentialAddress5] = useState('');
  const [maxlenth1, setmaxlenth1] = useState<number>();
  const [maxlenth2, setmaxlenth2] = useState<number>();
  const [maxlenth3, setmaxlenth3] = useState<number>();
  const [maxlenth4, setmaxlenth4] = useState<number>();
  const [visible, setVisibility] = useState<boolean>(false);
  const [policyNumberListforSelect, setPolicyNumberListforSelect] = useState([]);
  const [changePolicySelest, setchangePolicySelest] = useState(0);
  const shouleDisabled =
    form.getFieldValue('emailFlag') === 'Y' ||
    form.getFieldValue('mobileNumberFlag') === 'Y' ||
    form.getFieldValue('homeNumberFlag') === 'Y' ||
    form.getFieldValue('officeNumberFlag') === 'Y' ||
    form.getFieldValue('residentialAddressFlag') === 'Y';

  const selectCorrList = form.getFieldValue('selectCorrList') ?? [];
  // const defaultCountry = form.getFieldValue('residentialAddress5');
  const [officePhoneCountryCodedefaultValue] = useState(
    form.getFieldValue('officePhoneCountryCode') == ''
      ? '+852'
      : form.getFieldValue('officePhoneCountryCode').split(' ')[0],
  );
  const [mobilePhoneCountryCodedefaultValue] = useState(
    form.getFieldValue('mobilePhoneCountryCode') == ''
      ? '+852'
      : form.getFieldValue('mobilePhoneCountryCode').split(' ')[0],
  );
  const [homePhoneCountryCodedefaultValue] = useState(
    form.getFieldValue('homePhoneCountryCode') == ''
      ? '+852'
      : form.getFieldValue('homePhoneCountryCode').split(' ')[0],
  );
  // const [ContactInformation, setContactInformation] = useState('');
  // const navigate = useNavigate();
  const { shouldFetch: shouldFecthGetCountry, data: countriesDataList } = useGetCountriesNew(
    'useGetCountriesNew',
    token || '',
    '',
    '2',
  );
  const { Panel } = Collapse;
  const myCountryList = countriesDataList?.residentialCountries.map((item) => {
    return {
      label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
      value: item.t3645Alpha3Country,
      sanctionLevel: item.sanctionLevel,
    };
  });
  const myCountryList2 = countriesDataList?.residentialCountries.map((item) => {
    return {
      label: i18n.language == 'en' ? item.countryName : item.countryNameTc,
      value: item.t3645Alpha3Country,
      sanctionLevel: item.sanctionLevel,
      code: item.t3645Alpha3Country,
      descEn: item.countryName,
      descTc: item.countryNameTc,
    };
  });
  useEffect(() => {
    shouldFecthGetCountry(true);
  }, [shouldFecthGetCountry]);
  const [highRiskFlag, setHighRiskFlag] = useState(false);
  const changeCountry = (value: string) => {
    //如果這個value對應的國家的sanctionLevel為高風險，那麼返回true
    if (form.getFieldValue('residentialAddress5Origin') != value) {
      setHighRiskFlag(
        myCountryList2?.find((item) => item.code === value)?.sanctionLevel.toLowerCase() == 'HIGH'.toLowerCase(),
      );
      form.setFieldsValue({
        highRiskFlag:
          myCountryList2?.find((item) => item.code === value)?.sanctionLevel.toLowerCase() == 'HIGH'.toLowerCase(),
      });
    } else {
      //改回去時重置
      setHighRiskFlag(false);
      form.setFieldsValue({
        highRiskFlag: false,
      });
    }

    props.setShowTaxItem({
      ...props.showTaxItem,
      resAddress: form.getFieldValue('residentialAddress5Origin') != value,
    });
  };
  const handleofCover = () => {
    setSwich(true);
    setmrchecked(true);
    props.policyTypesObject?.map((item) => form.getFieldValue('selectedPolicy').push(item.policyNumber));
    form.setFieldsValue({ selectCorrList: [], highRiskFlag2: false }); //覆蓋后狀態清空，也沒有修改corr的list，所有相关状态都要清空，包括高风险也就沒有tax的展示
    setVisibility(false);
    props.setShowTaxItem({
      ...props.showTaxItem,
      corrAddress: false,
    });
  };
  const SwitchonChange = (checked: boolean) => {
    if (checked) {
      if (selectCorrList.length > 0) {
        return setVisibility(true);
      }
      setSwich(checked);
      setmrchecked(true); //打開全選
      props.policyTypesObject?.map((item) => form.getFieldValue('selectedPolicy').push(item.policyNumber));
      setPolicyNumberListforSelect(form.getFieldValue('selectedPolicy'));
      console.log('selectedPolicy', form.getFieldValue('selectedPolicy'));
    } else {
      setSwich(checked);
      setmrchecked(false); //關閉全選
      form.setFieldsValue({
        selectedPolicy: [],
      });
      setPolicyNumberListforSelect(form.getFieldValue('selectedPolicy'));
      console.log('selectedPolicy2', form.getFieldValue('selectedPolicy'));
    }
  };

  const CheckboxonChange = (e: CheckboxChangeEvent, item: string) => {
    console.log('eeeeeeee', e, item);
    setchangePolicySelest(Math.random());
    if (e.target.checked) {
      form.getFieldValue('selectedPolicy').push(item);
      console.log('selectedPolicy3', form.getFieldValue('selectedPolicy'));
      setPolicyNumberListforSelect(form.getFieldValue('selectedPolicy'));
    } else {
      setmrchecked(false);
      const index = form.getFieldValue('selectedPolicy').indexOf(item);
      if (index !== -1) {
        form.getFieldValue('selectedPolicy').splice(index, 1);
        console.log('删除', form.getFieldValue('selectedPolicy'));
        setPolicyNumberListforSelect(form.getFieldValue('selectedPolicy'));
      }
    }
  };
  const onCheckAllChange = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      setmrchecked(true);
      form.setFieldsValue({
        selectedPolicy: [],
      });
      props.policyTypesObject?.map((item) => form.getFieldValue('selectedPolicy').push(item.policyNumber));
      setPolicyNumberListforSelect(form.getFieldValue('selectedPolicy'));
      console.log('全选', form.getFieldValue('selectedPolicy'));
    } else {
      form.setFieldsValue({
        selectedPolicy: [],
      });
      setPolicyNumberListforSelect(form.getFieldValue('selectedPolicy'));
      console.log('全不选', form.getFieldValue('selectedPolicy'));
      setmrchecked(false);
    }
  };
  const handleChange = useCallback(
    // countrycode
    (value: string) => {
      form.setFieldsValue({
        mobilePhoneCountryCode: value,
      });
      props.setShowTaxItem({
        ...props.showTaxItem,
        mobileNumber:
          mobilePhoneCountryCodedefaultValue + props.mobilePhoneCountryCodeNameOri !=
            value.split(' ')[0] + props.mobilePhoneCountryCodeName && form.getFieldValue('mobileNumber')
            ? true
            : false,
      });
    },
    [form, mobilePhoneCountryCodedefaultValue, props],
  );

  const handleChange2 = useCallback(
    (value: string) => {
      form.setFieldsValue({
        homePhoneCountryCode: value,
      });
      props.setShowTaxItem({
        ...props.showTaxItem,
        homeNumber:
          homePhoneCountryCodedefaultValue + props.homePhoneCountryCodeNameOri !=
            value.split(' ')[0] + props.homePhoneCountryCodeName && form.getFieldValue('homeNumber')
            ? true
            : false,
      });
    },
    [form, props, homePhoneCountryCodedefaultValue],
  );
  const handleChange3 = useCallback(
    (value: string) => {
      form.setFieldsValue({
        officePhoneCountryCode: value,
      });
      // console.log('value', value);
      props.setShowTaxItem({
        ...props.showTaxItem,
        officeNumber:
          officePhoneCountryCodedefaultValue + props.officePhoneCountryCodeNameOri !=
            value.split(' ')[0] + props.officePhoneCountryCodeName && form.getFieldValue('officeNumber')
            ? true
            : false,
      });
    },
    [form, props, officePhoneCountryCodedefaultValue],
  );
  const handleButtonClick = () => {
    if (selectCorrList.length <= 0) {
      props.updateParentValue(true);
    }
  };
  useEffect(() => {
    if (props.showTaxItem.resAddress) {
      //true的時候有兩種情況，一種是住宅地址不同，一種是通訊地址與住宅地址不同
      if (form.getFieldValue('residentialAddress5Origin') != form.getFieldValue('residentialAddress5')) {
        return;
      } else {
        if (policyNumberListforSelect && policyNumberListforSelect.length > 0) {
          const selectedPolicy = props.policyTypesObject.filter((item) => {
            return policyNumberListforSelect.some((i: string) => i === item.policyNumber);
          });
          props.setShowTaxItem({
            ...props.showTaxItem,
            resAddress:
              canShowTax(props.policyTypesObject, selectedPolicy, form.getFieldValue('residentialAddress5')) ?? false,
          });
        } else {
          props.setShowTaxItem({
            ...props.showTaxItem,
            resAddress: false,
          });
        }
      }
    } else {
      if (policyNumberListforSelect && policyNumberListforSelect.length > 0) {
        const selectedPolicy = props.policyTypesObject.filter((item) => {
          return policyNumberListforSelect.some((i: string) => i === item.policyNumber);
        });
        props.setShowTaxItem({
          ...props.showTaxItem,
          resAddress:
            canShowTax(props.policyTypesObject, selectedPolicy, form.getFieldValue('residentialAddress5')) ?? false,
        });
      } else {
        props.setShowTaxItem({
          ...props.showTaxItem,
          resAddress: false,
        });
      }
    }
    // eslint-disable-next-line
  }, [policyNumberListforSelect, changePolicySelest, SwichCode, form, props.showTaxItem.resAddress]);
  useEffect(() => {
    if (form.getFieldValue('mobilePhoneCountryCode')) {
      handleChange(form.getFieldValue('mobilePhoneCountryCode'));
    } else {
      if (form.getFieldValue('mobileNumber')) {
        handleChange('+852');
      }
    }
    if (form.getFieldValue('homePhoneCountryCode')) {
      handleChange2(form.getFieldValue('homePhoneCountryCode'));
    } else {
      if (form.getFieldValue('homeNumber')) {
        handleChange2('+852');
      }
    }
    if (form.getFieldValue('officePhoneCountryCode')) {
      handleChange3(form.getFieldValue('officePhoneCountryCode'));
    } else {
      if (form.getFieldValue('officeNumber')) {
        handleChange3('+852');
      }
    }
    // eslint-disable-next-line
  }, [form]);
  // const containsChinese = (str: string) => {
  //   return /[\u4e00-\u9fa5]/.test(str);
  // };
  // const isTraditionalChinese = async (text: string) => {
  //   // 如果轉換後的文本與原文本不同，則可能是繁體
  //   const converter = Converter({ from: 'cn', to: 'hk' });
  //   return (await converter(text)) !== text;
  // };
  const ResidentialAddresschange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/[\u4e00-\u9fa5]/.test(e.target.value)) {
      setmaxlenth1(14);
    } else {
      setmaxlenth1(30);
    }
  };
  const ResidentialAddresschange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/[\u4e00-\u9fa5]/.test(e.target.value)) {
      setmaxlenth2(14);
    } else {
      setmaxlenth2(30);
    }
  };
  const ResidentialAddresschange3 = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/[\u4e00-\u9fa5]/.test(e.target.value)) {
      setmaxlenth3(14);
    } else {
      setmaxlenth3(30);
    }
  };
  const ResidentialAddresschange4 = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/[\u4e00-\u9fa5]/.test(e.target.value)) {
      setmaxlenth4(14);
    } else {
      setmaxlenth4(30);
    }
  };
  const verifyFun = /^[Ａ-Ｚａ-ｚ０-９A-Za-z0-9\u4e00-\u9fa5/／,，'‘’＇&＆ \u3000()（）.·．－-]+$/;
  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} style={{ rowGap: 0 }} className="concatform">
      <Col xs={24} md={24} style={{ opacity: shouleDisabled ? 0.4 : 1 }}>
        <BoldLabelFormItem
          label={
            <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
              {t('life.MakeRequest.contact.Name')}
            </span>
          }
          name="name"
        >
          <div
            style={{
              border: 'none',
              borderBottom: '1px solid #CCCCCC',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
            }}
          >
            {form.getFieldValue('name')}
          </div>
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24} style={{ opacity: shouleDisabled ? 0.4 : 1 }} ref={props.childRef}>
        {form.getFieldValue('emailFlag') === 'Y' && (
          <div
            style={{
              background: '#E9573D',
              borderRadius: '12px',
              padding: '4px 8px',
              fontSize: '15px',
              fontFamily: 'Roboto700',
              color: '#FFF',
              display: 'inline-block',
              height: '24px',
              lineHeight: '17px',
              marginTop: '16px',
            }}
          >
            {t('life.MakeRequest.contact.UnderReview')}
          </div>
        )}
        <Collapse
          accordion
          className="Collapse"
          expandIconPosition="end"
          collapsible={shouleDisabled ? 'disabled' : undefined}
          activeKey={props.activeKey1}
          onChange={() => {
            if (props.activeKey1) {
              props.setActiveKey1('');
            } else {
              props.setActiveKey1('1');
            }
          }}
        >
          <Panel header={t('life.MakeRequest.contact.Email')} key="1" forceRender={true}>
            <Form.Item
              preserve={true}
              name="email"
              rules={
                shouleDisabled
                  ? []
                  : [
                      { type: 'email', message: t('life.enquiry.error.emailerror') },
                      // () => ({
                      //   validator() {
                      //     if (form.getFieldValue('mobileNumber') == '') {
                      //       return Promise.reject(new Error(t('life.MakeRequest.contact.Emailcnc')));
                      //     } else {
                      //       return Promise.resolve();
                      //     }
                      //   },
                      // }),
                    ]
              }
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.MakeRequest.contact.Email')}
                </span>
              }
            >
              <Input
                size="middle"
                placeholder={t('life.enquiry.emailPlaceholder')}
                style={{
                  // color: "white",
                  // backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 10px',
                }}
              />
            </Form.Item>
            {props.cantchageemail && form.getFieldError('email').length == 0 && (
              <div>
                <span
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto700',
                    color: '#C21b17',
                  }}
                >
                  {t('life.MakeRequest.contact.Emailcnc')}
                </span>
              </div>
            )}
            {props.emailphone && form.getFieldError('email').length == 0 && (
              <div>
                <span
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto700',
                    color: '#C21b17',
                  }}
                >
                  {t('life.MakeRequest.contact.emailPhone')}
                </span>
              </div>
            )}
            {props.errorMessage == 'xapi.policy.email.has.been.used' &&
              !props.emailphone &&
              form.getFieldError('email').length == 0 && (
                <div>
                  <span
                    style={{
                      fontSize: '17px',
                      fontFamily: 'Roboto700',
                      color: '#C21b17',
                    }}
                  >
                    {i18n.language == 'en'
                      ? 'Email address has already been used, please retry with another email address.'
                      : '電郵地址已被使用，請使用其他電郵地址重試。'}
                  </span>
                </div>
              )}
          </Panel>
        </Collapse>
      </Col>
      <Col xs={24} md={24} style={{ opacity: shouleDisabled ? 0.4 : 1 }}>
        {(form.getFieldValue('mobileNumberFlag') === 'Y' ||
          form.getFieldValue('homeNumberFlag') === 'Y' ||
          form.getFieldValue('officeNumberFlag') === 'Y') && (
          <div
            style={{
              background: '#E9573D',
              borderRadius: '12px',
              padding: '4px 8px',
              fontSize: '15px',
              fontFamily: 'Roboto700',
              color: '#FFF',
              display: 'inline-block',
              height: '24px',
              lineHeight: '17px',
              marginTop: '16px',
            }}
          >
            {t('life.MakeRequest.contact.UnderReview')}
          </div>
        )}
        <Collapse
          accordion
          className="Collapse"
          expandIconPosition="end"
          collapsible={shouleDisabled ? 'disabled' : undefined}
          activeKey={props.activeKey2}
          onChange={() => {
            if (props.activeKey2) {
              props.setActiveKey2('');
            } else {
              props.setActiveKey2('2');
            }
          }}
        >
          <Panel header={t('life.MakeRequest.contact.PhoneNumbers')} key="2" className="mobale" forceRender={true}>
            <Form.Item
              preserve={true}
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.MakeRequest.contact.MobileNumber')}
                </span>
              }
            >
              <div className="countryCodestyle">
                <Form.Item name="mobilePhoneCountryCode" preserve={true}>
                  {/* <MobileNumberPrefix defaultValue={mobilePhoneCountryCodedefaultValue} handleChange={handleChange} /> */}
                  <MobileNumberHasAreaPrefix
                    defaultValue={mobilePhoneCountryCodedefaultValue}
                    defaultAreacode={form.getFieldValue('mobileAreaCode')}
                    defaultCountry={form.getFieldValue('mobileCountry')}
                    handleSetCountry={props.setmobilePhoneCountryCodeName}
                    handleCountryOri={props.setmobilePhoneCountryCodeNameOri}
                    handleChange={handleChange}
                    border
                    areacodeFlag={props.mobileAreaCodeFlag}
                  />
                </Form.Item>
              </div>
              <div className="phonestyle">
                <Form.Item
                  preserve={true}
                  rules={
                    shouleDisabled
                      ? []
                      : [
                          // { required: requiresMailOrPhone, message: t('enquiry.error.contactError') },
                          () => ({
                            validator(_, value) {
                              if (
                                !value ||
                                (form.getFieldValue('mobilePhoneCountryCode').trim() == '+852' ||
                                !form.getFieldValue('mobilePhoneCountryCode')
                                  ? mobileRegexhk.test(value)
                                  : mobileRegexNew.test(value))
                              ) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject(new Error(t('registration.error.invalidMobile')));
                              }
                            },
                          }),
                        ]
                  }
                  required
                  name="mobileNumber"
                >
                  <Input
                    size="middle"
                    placeholder={t('life.MakeRequest.contact.MobileNumber')}
                    style={{
                      // color: "white",
                      // backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      marginBottom: '10px',
                      padding: '4px 10px',
                      height: '40px',
                    }}
                    onBlur={() => {
                      props.setShowTaxItem({
                        ...props.showTaxItem,
                        mobileNumber:
                          mobilePhoneCountryCodedefaultValue + props.mobilePhoneCountryCodeNameOri !=
                            form.getFieldValue('mobilePhoneCountryCode').split(' ')[0] +
                              props.mobilePhoneCountryCodeName && form.getFieldValue('mobileNumber')
                            ? true
                            : false,
                      });
                    }}
                  />
                </Form.Item>
              </div>
            </Form.Item>
            {props.cantchagephone && form.getFieldError('mobileNumber').length == 0 && (
              <div>
                <span
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto700',
                    color: '#C21b17',
                  }}
                >
                  {t('life.MakeRequest.contact.phonecnc')}
                </span>
              </div>
            )}
            {props.emailphone && form.getFieldError('mobileNumber').length == 0 && (
              <div>
                <span
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto700',
                    color: '#C21b17',
                  }}
                >
                  {t('life.MakeRequest.contact.emailPhone')}
                </span>
              </div>
            )}
            {props.errorMessage == 'xapi.policy.mobilenumber.has.been.used' &&
              !props.emailphone &&
              form.getFieldError('mobileNumber').length == 0 && (
                <div>
                  <span
                    style={{
                      fontSize: '17px',
                      fontFamily: 'Roboto700',
                      color: '#C21b17',
                    }}
                  >
                    {i18n.language == 'en'
                      ? 'Mobile has already been used, please retry with another Mobile.'
                      : '手機號碼已被使用，請使用其他手機號碼重試。'}
                  </span>
                </div>
              )}
            <Form.Item
              preserve={true}
              name="homeNumber"
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.MakeRequest.contact.HomeNumber')}
                </span>
              }
            >
              <div className="countryCodestyle">
                <Form.Item name="homePhoneCountryCode" preserve={true}>
                  {/* <MobileNumberPrefix defaultValue={homePhoneCountryCodedefaultValue} handleChange={handleChange2} /> */}
                  <MobileNumberHasAreaPrefix
                    defaultValue={homePhoneCountryCodedefaultValue}
                    defaultAreacode={form.getFieldValue('homeAreaCode')}
                    defaultCountry={form.getFieldValue('homeCountry')}
                    handleSetCountry={props.sethomePhoneCountryCodeeName}
                    handleCountryOri={props.sethomePhoneCountryCodeeNameOri}
                    handleChange={handleChange2}
                    border
                    areacodeFlag={props.homeAreaCodeFlag}
                  />
                </Form.Item>
              </div>
              <div className="phonestyle">
                <Form.Item
                  preserve={true}
                  rules={
                    shouleDisabled
                      ? []
                      : [
                          // { required: requiresMailOrPhone, message: t('enquiry.error.contactError') },
                          () => ({
                            validator(_, value) {
                              if (
                                !value ||
                                (form.getFieldValue('homePhoneCountryCode').trim() == '+852' ||
                                !form.getFieldValue('homePhoneCountryCode')
                                  ? mobileRegexhk.test(value)
                                  : mobileRegexNew.test(value))
                              ) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject(new Error(t('registration.error.invalidMobile')));
                              }
                            },
                          }),
                        ]
                  }
                  required
                  name="homeNumber"
                >
                  <Input
                    size="middle"
                    placeholder={t('life.MakeRequest.contact.HomeNumber')}
                    style={{
                      // color: "white",
                      // backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      marginBottom: '10px',
                      padding: '4px 10px',
                      height: '40px',
                    }}
                    onBlur={() =>
                      props.setShowTaxItem({
                        ...props.showTaxItem,
                        homeNumber:
                          homePhoneCountryCodedefaultValue + props.homePhoneCountryCodeNameOri !=
                            form.getFieldValue('homePhoneCountryCode').split(' ')[0] + props.homePhoneCountryCodeName &&
                          form.getFieldValue('homeNumber')
                            ? true
                            : false,
                      })
                    }
                  />
                </Form.Item>
              </div>
            </Form.Item>
            {/* {props.errorMessage == 'xapi.policy.homenumber.has.been.used' && !props.emailphone && (
              <div>
                <span
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto700',
                    color: '#C21b17',
                  }}
                >
                  {i18n.language == 'en'
                    ? 'Mobile has already been used, please retry with another Mobile.'
                    : '手機號碼已被使用，請使用其他手機號碼重試。'}
                </span>
              </div>
            )} */}
            <Form.Item
              preserve={true}
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.MakeRequest.contact.OfficeNumber')}
                </span>
              }
            >
              <div className="countryCodestyle">
                <Form.Item name="officePhoneCountryCode" preserve={true}>
                  {/* <MobileNumberPrefix defaultValue={officePhoneCountryCodedefaultValue} handleChange={handleChange3} /> */}
                  <MobileNumberHasAreaPrefix
                    defaultValue={officePhoneCountryCodedefaultValue}
                    defaultAreacode={form.getFieldValue('officeAreaCode')}
                    defaultCountry={form.getFieldValue('officeCountry')}
                    handleSetCountry={props.setofficePhoneCountryCodeName}
                    handleCountryOri={props.setofficePhoneCountryCodeNameOri}
                    handleChange={handleChange3}
                    border
                    areacodeFlag={props.officeAreaCodeFlag}
                  />
                </Form.Item>
              </div>
              <div className="phonestyle">
                <Form.Item
                  preserve={true}
                  rules={
                    shouleDisabled
                      ? []
                      : [
                          // { required: requiresMailOrPhone, message: t('enquiry.error.contactError') },
                          () => ({
                            validator(_, value) {
                              if (
                                !value ||
                                (form.getFieldValue('officePhoneCountryCode').trim() == '+852' ||
                                !form.getFieldValue('officePhoneCountryCode')
                                  ? mobileRegexhk.test(value)
                                  : mobileRegexNew.test(value))
                              ) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject(new Error(t('registration.error.invalidMobile')));
                              }
                            },
                          }),
                        ]
                  }
                  required
                  name="officeNumber"
                >
                  <Input
                    size="middle"
                    placeholder={t('life.MakeRequest.contact.OfficeNumber')}
                    style={{
                      // color: "white",
                      // backgroundColor: 'transparent',
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      marginBottom: '10px',
                      padding: '4px 10px',
                      height: '40px',
                    }}
                    onBlur={() =>
                      props.setShowTaxItem({
                        ...props.showTaxItem,
                        officeNumber:
                          officePhoneCountryCodedefaultValue + props.officePhoneCountryCodeNameOri !=
                            form.getFieldValue('officePhoneCountryCode').split(' ')[0] +
                              props.officePhoneCountryCodeName && form.getFieldValue('officeNumber')
                            ? true
                            : false,
                      })
                    }
                  />
                </Form.Item>
              </div>
            </Form.Item>
            {/* {props.errorMessage == 'xapi.policy.officenumber.has.been.used' && !props.emailphone && (
              <div>
                <span
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto700',
                    color: '#C21b17',
                  }}
                >
                  {i18n.language == 'en'
                    ? 'Mobile has already been used, please retry with another Mobile.'
                    : '手機號碼已被使用，請使用其他手機號碼重試。'}
                </span>
              </div>
            )} */}
          </Panel>
        </Collapse>
      </Col>
      <Col xs={24} md={24} style={{ opacity: shouleDisabled ? 0.4 : 1 }}>
        {form.getFieldValue('residentialAddressFlag') === 'Y' && (
          <div
            style={{
              background: '#E9573D',
              borderRadius: '12px',
              padding: '4px 8px',
              fontSize: '15px',
              fontFamily: 'Roboto700',
              color: '#FFF',
              display: 'inline-block',
              height: '24px',
              lineHeight: '17px',
              marginTop: '16px',
            }}
          >
            {t('life.MakeRequest.contact.UnderReview')}
          </div>
        )}
        <Collapse
          accordion
          className="Collapse change-residential"
          expandIconPosition="end"
          collapsible={shouleDisabled ? 'disabled' : undefined}
          activeKey={props.activeKey3}
          onChange={() => {
            if (props.activeKey3) {
              props.setActiveKey3('');
            } else {
              props.setActiveKey3('3');
            }
          }}
        >
          <Panel header={t('life.MakeRequest.contact.ResidentialAddress')} key="3" forceRender={true}>
            <p
              style={{
                color: '#6f7072',
                fontWeight: 'normal',
                fontSize: '17px',
                fontFamily: 'Roboto400',
                paddingLeft: '16px',
                paddingRight: '16px',
                marginBottom: 0,
              }}
            >
              {t('life.MakeRequest.contact.maxResidentialAddress2')}{' '}
            </p>
            {/* <span
              style={{
                color: '#6f7072',
                fontWeight: 'normal',
                fontSize: '17px',
                fontFamily: 'Roboto400',
                paddingLeft: '16px',
                paddingRight: '16px',
              }}
            >
              {t('life.MakeRequest.contact.maxResidentialAddress2')}
            </span> */}
            <Form.Item
              preserve={true}
              rules={
                shouleDisabled
                  ? []
                  : [
                      { required: true, message: t('common.error.requiredField') },
                      {
                        validator: async (_, value) => {
                          if (!value) return Promise.resolve();
                          const isValidChars = verifyFun.test(value);
                          if (!isValidChars) {
                            return Promise.reject(new Error(t('life.MakeRequest.contact.tcError'))); // 替换为你的翻译键
                          }
                          // if (await isTraditionalChinese(value)) {
                          //   // 返回 Promise.reject 会触发表单错误
                          //   return Promise.reject(new Error(t('life.MakeRequest.contact.tcError')));
                          // }
                          return Promise.resolve(); // 验证通过
                        },
                      },
                    ]
              }
              name="residentialAddress1"
              // label={
              //   <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              //     {t('life.MakeRequest.contact.ResidentialAddress')}
              //   </span>
              // }
            >
              <Input
                size="middle"
                placeholder={t('life.MakeRequest.contact.line1')}
                maxLength={maxlenth1}
                onChange={ResidentialAddresschange}
                style={{
                  // color: "white",
                  // backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 10px',
                }}
              />
            </Form.Item>
            <Form.Item
              preserve={true}
              name="residentialAddress2"
              rules={
                shouleDisabled
                  ? []
                  : [
                      { required: true, message: t('common.error.requiredField') },
                      {
                        validator: async (_, value) => {
                          if (!value) return Promise.resolve();
                          const isValidChars = verifyFun.test(value);
                          if (!isValidChars) {
                            return Promise.reject(new Error(t('life.MakeRequest.contact.tcError'))); // 替换为你的翻译键
                          }
                          // if (await isTraditionalChinese(value)) {
                          //   // 返回 Promise.reject 会触发表单错误
                          //   return Promise.reject(new Error(t('life.MakeRequest.contact.tcError')));
                          // }
                          return Promise.resolve(); // 验证通过
                        },
                      },
                    ]
              }
            >
              <Input
                size="middle"
                placeholder={t('life.MakeRequest.contact.line2')}
                maxLength={maxlenth2}
                onChange={ResidentialAddresschange2}
                style={{
                  // color: "white",
                  // backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 10px',
                }}
              />
            </Form.Item>
            <Form.Item
              preserve={true}
              name="residentialAddress3"
              rules={
                shouleDisabled
                  ? []
                  : [
                      {
                        validator: async (_, value) => {
                          if (!value) return Promise.resolve();
                          const isValidChars = verifyFun.test(value);
                          if (!isValidChars) {
                            return Promise.reject(new Error(t('life.MakeRequest.contact.tcError'))); // 替换为你的翻译键
                          }
                          // if (await isTraditionalChinese(value)) {
                          //   // 返回 Promise.reject 会触发表单错误
                          //   return Promise.reject(new Error(t('life.MakeRequest.contact.tcError')));
                          // }
                          return Promise.resolve(); // 验证通过
                        },
                      },
                    ]
              }
            >
              <Input
                size="middle"
                placeholder={t('life.MakeRequest.contact.line3')}
                maxLength={maxlenth3}
                onChange={ResidentialAddresschange3}
                style={{
                  // color: "white",
                  // backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 10px',
                }}
              />
            </Form.Item>
            <Form.Item
              preserve={true}
              name="residentialAddress4"
              rules={
                shouleDisabled
                  ? []
                  : [
                      {
                        validator: async (_, value) => {
                          if (!value) return Promise.resolve();
                          const isValidChars = verifyFun.test(value);
                          if (!isValidChars) {
                            return Promise.reject(new Error(t('life.MakeRequest.contact.tcError'))); // 替换为你的翻译键
                          }
                          // if (await isTraditionalChinese(value)) {
                          //   // 返回 Promise.reject 会触发表单错误
                          //   return Promise.reject(new Error(t('life.MakeRequest.contact.tcError')));
                          // }
                          return Promise.resolve(); // 验证通过
                        },
                      },
                    ]
              }
            >
              <Input
                size="middle"
                placeholder={t('life.MakeRequest.contact.line4')}
                maxLength={maxlenth4}
                onChange={ResidentialAddresschange4}
                style={{
                  // color: "white",
                  // backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 10px',
                }}
              />
            </Form.Item>
            <Form.Item name="residentialAddress5" preserve={true}>
              <Select
                showSearch
                onChange={changeCountry}
                popupClassName="slectop2"
                placeholder={t('life.MakeRequest.contact.line5')}
                filterOption={(input, myCountryList) =>
                  (myCountryList?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                style={{
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                }}
                options={myCountryList}
              ></Select>
            </Form.Item>
            {highRiskFlag && (
              <div>
                <span
                  style={{
                    paddingLeft: '16px',
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    color: '#6F7072',
                  }}
                >
                  {t('life.MakeRequest.contact.uploadaddress')}
                </span>
              </div>
            )}
            {props.policyTypesObject?.find((i) => i.correspondenceAddressFlag == 'Y') == undefined && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingLeft: '16px',
                  paddingRight: '16px',
                  paddingBottom: '16px',
                  borderBottom: SwichCode ? '1px solid #ccc' : '0px',
                }}
              >
                <div
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto500',
                    color: '#C21b17',
                  }}
                >
                  {t('life.MakeRequest.contact.AsCorrespondence')}
                </div>
                {/* 有Y則隱藏，不允許修改 */}

                <div>
                  <Switch
                    checked={SwichCode}
                    onChange={SwitchonChange}
                    defaultChecked={(form.getFieldValue('selectedPolicy') ?? []).length > 0}
                  />
                </div>
              </div>
            )}
            {SwichCode && (
              <Form.Item
                preserve={true}
                label={
                  <span
                    style={{
                      color: '#6f7072',
                      fontWeight: 'normal',
                      fontSize: '17px',
                      fontFamily: 'Roboto400',
                      paddingTop: '10px',
                    }}
                  >
                    {t('life.MakeRequest.SelectPolicy')}
                  </span>
                }
                className="crossCheckbox"
              >
                <Checkbox
                  className="corrCardCheckBox"
                  onChange={onCheckAllChange}
                  defaultChecked={SwichCode}
                  style={{ borderBottom: '1px solid #CCCCCC' }}
                >
                  <span
                    style={{
                      fontWeight: 'normal',
                      fontSize: '17px',
                      fontFamily: 'Roboto400',
                      // marginTop: '10px',
                      color: '#20252B',
                      paddingLeft: 0,
                    }}
                  >
                    {i18n.language == 'en' ? 'All policies' : '所有保單'}
                  </span>
                </Checkbox>
                {mrchecked &&
                  props.policyTypesObject?.map((item, index) => (
                    <Checkbox
                      className="corrCardCheckBox"
                      checked={true}
                      onChange={(e) => {
                        CheckboxonChange(e, item.policyNumber);
                      }}
                      style={{ borderBottom: '1px solid #CCCCCC' }}
                      key={index + 'policyTypes'}
                      defaultChecked={form.getFieldValue('selectedPolicy').includes(item.policyNumber)}
                    >
                      <div
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          // marginTop: '10px',
                        }}
                      >
                        {i18n.language == 'en' ? item.productName : item.productNameTc}
                      </div>
                      <div
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto500',
                          marginBottom: '10px',
                          borderBottom: '1px solid #CCCCCC',
                        }}
                      >
                        {`${t('life.enquiry.policyNo')}${item.policyNumber}`}
                      </div>
                      <div style={{ fontSize: '17px', fontFamily: 'Roboto400', fontWeight: 'bold' }}>
                        {t('life.MakeRequest.contact.currentAddress')}
                      </div>
                      <div
                        key={index + item.corrAddress1}
                        style={{
                          border: 'none',
                          // color: "white",
                          backgroundColor: 'transparent',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        {item.corrAddress1}
                      </div>
                      <div
                        key={index + item.corrAddress2}
                        style={{
                          border: 'none',
                          // color: "white",
                          backgroundColor: 'transparent',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        {item.corrAddress2}
                      </div>
                      <div
                        key={index + item.corrAddress3}
                        style={{
                          border: 'none',
                          // color: "white",
                          backgroundColor: 'transparent',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        {item.corrAddress3}
                      </div>
                      <div
                        key={index + item.corrAddress4}
                        style={{
                          border: 'none',
                          // color: "white",
                          backgroundColor: 'transparent',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        {item.corrAddress4}
                      </div>
                      {/* <div
                        key={index + item.corrAddress5}
                        style={{
                          border: 'none',
                          // color: "white",
                          backgroundColor: 'transparent',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        {myCountryList?.find((i) => i.value === item.corrAddressCountry)?.label}
                      </div> */}
                    </Checkbox>
                  ))}
                {!mrchecked &&
                  props.policyTypesObject?.map((item, index) => (
                    <div key={index + 'policyT'}>
                      {selectCorrList.length > 0 && selectCorrList.includes(item.policyNumber) && (
                        <div
                          style={{
                            background: '#E9573D',
                            borderRadius: '20px',
                            padding: '4px 8px',
                            fontSize: '15px',
                            fontFamily: 'Roboto700',
                            color: '#FFF',
                            display: 'inline-block',
                            height: '24px',
                            lineHeight: '17px',
                            marginTop: '16px',
                          }}
                        >
                          {t('life.MakeRequest.contact.updatedPending')}
                        </div>
                      )}
                      <Checkbox
                        className="corrCardCheckBox"
                        style={{ borderBottom: '1px solid #CCCCCC' }}
                        onChange={(e) => {
                          CheckboxonChange(e, item.policyNumber);
                        }}
                        defaultChecked={form.getFieldValue('selectedPolicy').includes(item.policyNumber)}
                        disabled={selectCorrList.length > 0 ? selectCorrList.includes(item.policyNumber) : false}
                      >
                        <div
                          style={{
                            color: '#6f7072',
                            fontWeight: 'normal',
                            fontSize: '17px',
                            fontFamily: 'Roboto500',
                            // marginTop: '10px',
                          }}
                        >
                          {i18n.language == 'en' ? item.productName : item.productNameTc}
                        </div>
                        <div
                          style={{
                            color: '#6f7072',
                            fontWeight: 'normal',
                            fontSize: '17px',
                            fontFamily: 'Roboto500',
                            marginBottom: '10px',
                            borderBottom: '1px solid #CCCCCC',
                          }}
                        >
                          {`${t('life.enquiry.policyNo')}${item.policyNumber}`}
                        </div>
                        <div style={{ fontSize: '17px', fontFamily: 'Roboto400', fontWeight: 'bold' }}>
                          {t('life.MakeRequest.contact.currentAddress')}
                        </div>
                        <div
                          key={index + item.corrAddress1}
                          style={{
                            border: 'none',
                            // color: "white",
                            backgroundColor: 'transparent',
                            fontSize: '17px',
                            fontFamily: 'Roboto400',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          {item.corrAddress1}
                        </div>
                        <div
                          key={index + item.corrAddress2}
                          style={{
                            border: 'none',
                            // color: "white",
                            backgroundColor: 'transparent',
                            fontSize: '17px',
                            fontFamily: 'Roboto400',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          {item.corrAddress2}
                        </div>
                        <div
                          key={index + item.corrAddress3}
                          style={{
                            border: 'none',
                            // color: "white",
                            backgroundColor: 'transparent',
                            fontSize: '17px',
                            fontFamily: 'Roboto400',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          {item.corrAddress3}
                        </div>
                        <div
                          key={index + item.corrAddress4}
                          style={{
                            border: 'none',
                            // color: "white",
                            backgroundColor: 'transparent',
                            fontSize: '17px',
                            fontFamily: 'Roboto400',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          {item.corrAddress4}
                        </div>
                        {/* <div
                          key={index + item.corrAddress5}
                          style={{
                            border: 'none',
                            // color: "white",
                            backgroundColor: 'transparent',
                            fontSize: '17px',
                            fontFamily: 'Roboto400',
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          {myCountryList?.find((i) => i.value === item.corrAddressCountry)?.label}
                        </div> */}
                      </Checkbox>
                    </div>
                  ))}
              </Form.Item>
            )}
          </Panel>
        </Collapse>
        <div
          style={{
            fontSize: '17px',
            fontFamily: 'Roboto400',
            color: '#6F7072',
            // borderBottom: '1px solid #CCCCCC',
            width: '100%',
            paddingBottom: '20px',
            paddingTop: '20px',
          }}
        >
          <span>{t('life.MakeRequest.contact.information')}</span>
        </div>

        <div>
          <div
            style={{
              height: '20px',
              backgroundColor: '#F6F6F6',
            }}
          ></div>
        </div>
      </Col>

      <Col xs={24} md={24}>
        <div
          style={{
            fontSize: '22px',
            fontFamily: 'Roboto400',
            color: '#6F7072',
            borderBottom: '1px solid #CCCCCC',
            width: '100%',
            paddingBottom: '20px',
            paddingTop: '20px',
          }}
        >
          {t('life.MakeRequest.contact.PolicyInformation')}
        </div>
        {selectCorrList.length > 0 && (
          <div
            style={{
              background: '#E9573D',
              borderRadius: '20px',
              padding: '4px 8px',
              fontSize: '15px',
              fontFamily: 'Roboto700',
              color: '#FFF',
              display: 'inline-block',
              height: '24px',
              lineHeight: '17px',
              marginTop: '16px',
            }}
          >
            {t('life.MakeRequest.contact.updatedPending')}
          </div>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            borderBottom: '1px solid #CCCCCC',
            opacity: selectCorrList.length > 0 ? 0.4 : 1,
            cursor: 'pointer',
          }}
          onClick={handleButtonClick}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                fontFamily: 'Roboto500',
                fontSize: '20px',
                color: '#6F7072',
                paddingTop: '10px',
                paddingBottom: '10px',
              }}
            >
              {t('life.MakeRequest.contact.CorrespondenceAddress')}
            </span>
          </div>
          <img src={ChevronRight} style={{ margin: '0  10px 0 0', width: '8px', height: '14px' }} />
        </div>
      </Col>

      {props.showTaxItem.corrAddress ||
      props.showTaxItem.resAddress ||
      props.showTaxItem.homeNumber ||
      props.showTaxItem.mobileNumber ||
      props.showTaxItem.officeNumber ? (
        <Col xs={24} md={24}>
          <div style={{ fontSize: '22px', fontFamily: 'Roboto400', paddingTop: '15px', color: '#20252b' }}>
            <span>{t('life.MakeRequest.contact.termstittle')}</span>
          </div>
          <div
            style={{
              fontSize: '15px',
              fontFamily: 'Roboto400',
              paddingTop: '15px',
              color: '#20252b',
              fontWeight: '500',
              paddingBottom: '15px',
              borderBottom: '1px solid #CCCCCC',
            }}
          >
            <span>{t('life.MakeRequest.contact.terms')}</span>
          </div>
          <div
            style={{
              fontSize: '15px',
              fontFamily: 'Roboto400',
              paddingTop: '15px',
              color: '#6F7072',
              paddingBottom: '15px',
              borderBottom: '1px solid #CCCCCC',
            }}
          >
            <div>{t('life.MakeRequest.contact.tax1')}</div>

            <Radio.Group onChange={(e) => props.setTax1Value(e.target.value)} value={props.tax1Value}>
              <Radio key={'tax1_Y'} value={'Yes'} style={{ marginRight: '130px', color: '#6F7072' }}>
                {t('life.MakeRequest.contact.yes')}
              </Radio>
              <Radio key={'tax1_N'} value={'No'} style={{ color: '#6F7072' }}>
                {t('life.MakeRequest.contact.no')}
              </Radio>
            </Radio.Group>

            {props.tax1Value == 'No' && (
              // <MarkdownTargetBlank>
              //   {t('life.MakeRequest.contact.tax1no', { url: props.taxLink.tax1 })}
              // </MarkdownTargetBlank>
              <div style={{ color: '#C21B17' }}>{t('life.MakeRequest.contact.tax1Desc')}</div>
            )}
          </div>
          <div
            style={{
              fontSize: '15px',
              fontFamily: 'Roboto400',
              paddingTop: '15px',
              color: '#6F7072',
              paddingBottom: '15px',
              borderBottom: '1px solid #CCCCCC',
            }}
          >
            <div>{t('life.MakeRequest.contact.tax2')}</div>

            <Radio.Group onChange={(e) => props.setTax2Value(e.target.value)} value={props.tax2Value}>
              <Radio key={'tax2_Y'} value={'Yes'} style={{ marginRight: '130px', color: '#6F7072' }}>
                {t('life.MakeRequest.contact.yes')}
              </Radio>
              <Radio key={'tax2_N'} value={'No'} style={{ color: '#6F7072' }}>
                {t('life.MakeRequest.contact.no')}
              </Radio>
            </Radio.Group>
            {props.tax2Value == 'No' && (
              // <MarkdownTargetBlank>
              //   {t('life.MakeRequest.contact.tax2no', { url: props.taxLink.tax2 })}
              // </MarkdownTargetBlank>
              <div style={{ color: '#C21B17' }}>{t('life.MakeRequest.contact.tax2Desc')}</div>
            )}
          </div>
        </Col>
      ) : (
        <Col xs={24} md={24}>
          {/* <BoldLabelFormItem
            style={{
              fontSize: '17px',
              fontFamily: 'Roboto400',
              color: '#6F7072',
              borderBottom: '1px solid #CCCCCC',
              width: '100%',
              paddingBottom: '20px',
            }}
          > */}
          <div
            style={{
              fontSize: '17px',
              fontFamily: 'Roboto400',
              color: '#6F7072',
              borderBottom: '1px solid #CCCCCC',
              width: '100%',
              paddingBottom: '10px',
              marginTop: '10px',
            }}
          >
            <span>{t('life.MakeRequest.contact.terms')}</span>
          </div>
          {/* </BoldLabelFormItem> */}
        </Col>
      )}
      <AgreementCard />
      <div
        style={{
          fontSize: '17px',
          fontFamily: 'Roboto400',
          paddingLeft: '1.5px',
          paddingTop: '15px',
          color: '#20252b',
        }}
      >
        <span>{t('life.MakeRequest.contact.accepttext2')}</span>
      </div>
      <CoverModal
        handleOk={handleofCover}
        visible={visible}
        setVisibility={setVisibility}
        modalLoading={false}
        title={t('life.MakeRequest.contact.apply')}
        description={t('life.MakeRequest.contact.overwritten')}
      />
    </Row>
  );
};
